import { useState } from "react";
import { MODULE_API } from "../../../../apis";
import useModuleData from "./useFetchItems";
export default function useCreateAttribute(
  moduleName,
  formData,
  setFormData,
  setToUpdate,
  fetchData,
  formatModuleKey,
  setTableData,
  setLoading
) {
  const [error, setError] = useState(false);

  const createAttributes = async () => {
    try {
      setLoading(true);
      const response = await MODULE_API.addAsset(moduleName, {
        clientModules: [formData],
      });
      const res = await fetchData(moduleName);
      setTableData((prev) => ({
        ...prev,
        [formatModuleKey(moduleName)]: res && res.records ? res.records : [],
      }));
      setLoading(false);
      setFormData(null);
      setToUpdate(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setFormData(null);
    }
  };
  return { createAttributes, error };
}
